import React, { useState, useEffect } from "react";
import { useSelector, connect } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import { LocalStorageService, toAbsoluteUrl } from "../../../services";
import {
  getListsCampaignData,
  listGetAllTags,
  sendSingleInvite,
  resetInvite,
  sendReminder,
  saveTemplate,
  bulkInvites,
  getCustomListEmails,
} from "../../../redux/actions/nrp/inviteActions";
import CustomToolbar from "./toolbar";
import "./grid.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { UploadFile, DateTimePicker } from "../../components";
import {Input,Button} from "../../../components"
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import moment from "moment";
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
import Papa from "papaparse";
import Select from "react-dropdown-select";

import { dummyEmails } from "./data";

// get step data from redux main state
const data = (state) => state.nrpInvite;

const Invite = (props) => {
  let { campaginData, isLoading, tagsList } = useSelector(data);
  const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(0);
  const [dataLoading, setDataLoading] = useState(isLoading);
  const [headers, setHeaders] = useState([]);
  const [campaign] = useState(LocalStorageService.getObject("campaign")[0]);
  const [allUsers, setallUsers] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [selectedUsersIds, setSelectedUsersIds] = React.useState([]);
  const [overAllSelectedUsers, setOverAllSelectedUsers] = useState([]);
  const [allSelectedUsersIds, setAllSelectedUsersIds] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [sortingModal, setSortModel] = useState([{ field: null, sort: null }]);
  const [currentStep, setCurrentStep] = useState("InvitedUsers");
  const [resetUser, setResetUser] = useState();
  const [reminderUser, setReminderUser] = useState();
  const [expiryNewDate, setNewExpiry] = useState();
  const [message, setMessage] = useState();
  const [campaignEmail, setCampaignEmail] = useState("");
  const [emailSubject, setEmailSubject] = useState();
  const [editorState, setEditorState] = useState("");
  const [bulkInviteEmails, setBulkInviteEmails] = useState("");
  const [bulkInviteFileName, setBulkInviteFileName] = useState("");
  const [taglistItems, settagListItems] = useState([]);
  const [selectedListItem, setSelectedListItem] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const emailSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email address").required("Required"),
  });

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: emailSchema,
    onSubmit: (values) => {
      let email = values.email;
      props.sendSingleInvite(campaign, email);
    },
  });

  useEffect(() => {
    props.getListsCampaignData(
      campaign,
      pageNumber,
      pageSize,
      searchValue,
      sortingModal
    );
  }, [pageNumber, pageSize, searchValue, sortingModal]);

  const handleSelectionChange = (prodID) => {
    const selectedIDs = new Set(prodID);
    const selectedRows = rowData.filter((row) => selectedIDs.has(row.id));
    setSelectedRows(selectedRows);
    setSelectedUsersIds(prodID);
    setAllSelectedUsersIds(prodID);
    let data = [...overAllSelectedUsers, ...selectedRows];
    data = data.filter((row) => selectedIDs.has(row.id));
    setOverAllSelectedUsers([...new Set(data)]);
  };

  let handelPage = (page) => {
    setDataLoading(!dataLoading);
    setPageNumber(page);
  };

  const handelCellClick = (params) => {
    let { field, row } = params;
    if (field === "reminder") {
      let data = row;
      setCurrentStep("ReminderInvite");
      setReminderUser(data);
    }
    if (field === "reset") {
      let data = row;
      setCurrentStep("ResetInvite");
      setResetUser(data);
    }
  };

  // get searched data from toolbar to parent component
  let handelSearchCandidate = (searchValue) => {
    setSearchValue(searchValue);
    setPageNumber(0);
  };

  let defaultApiCall = () => {
    props.getListsCampaignData(
      campaign,
      pageNumber,
      pageSize,
      searchValue,
      sortingModal
    );
  };

  let customStep = (step) => {
    setCurrentStep(step);
  };

  let resetInviteHandle = () => {
    let user = {
      email: resetUser.email,
      message: null,
      date: expiryNewDate,
    };
    props.resetInvite(campaign, user);
    setTimeout(() => {
      setCurrentStep("InvitedUsers");
      props.getListsCampaignData(
        campaign,
        pageNumber,
        pageSize,
        searchValue,
        sortingModal
      );
    }, 500);
  };

  let sendReminderHandle = () => {
    if (!message) {
      toast("Template Required!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else {
      let user = {
        email: reminderUser.email,
        message: message,
        date: expiryNewDate,
      };
      props.sendReminder(campaign, user);
      setTimeout(() => {
        setCurrentStep("InvitedUsers");
        props.getListsCampaignData(
          campaign,
          pageNumber,
          pageSize,
          searchValue,
          sortingModal
        );
      }, 900);
    }
  };

  let saveEmailTemplate = () => {
    let settings = {
      campaignEmail: campaignEmail,
      emailSubject: emailSubject,
      emailTemplate: editorState,
    };
    props.saveTemplate(campaign, settings);
    setTimeout(() => {
      setCurrentStep("InvitedUsers");
      props.getListsCampaignData(
        campaign,
        pageNumber,
        pageSize,
        searchValue,
        sortingModal
      );
    }, 900);
  };

  let uploadBulkInvites = (event) => {
    let file = event.target.files[0];
    if (/\.(csv)$/i.test(file.name)) {
      Papa.parse(file, {
        header: false,
        skipEmptyLines: true,
        complete: function (data) {
          let results = data;
          const valuesArray = [];
          results.data.map((item, index) => {
            if (index !== 0) {
              valuesArray.push({
                name: item[0],
              });
            }
          });
          setBulkInviteFileName(file.name);
          setBulkInviteEmails(valuesArray);
        },
      });
    } else {
      toast("You can't upload this type of file.", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        type: "error",
      });
    }
  };

  let bulkInvitesHandle = () => {
    // console.log(bulkInviteEmails)
    props.bulkInvites(campaign, bulkInviteEmails);
  };

  let listEmailInvitesHandle = () => {
    if (selectedListItem && selectedListItem.length > 0) {
      let selectedList = selectedListItem[0];
      let filter = [
        {
          columnName: "tagId",
          columnType: "tagId",
          value: selectedList && selectedList.id,
        },
      ];
      props.getCustomListEmails(campaign, 1, 1000, filter);
    } else {
      toast("Please Select List!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        type: "error",
      });
    }
  };

  let handleDropdown = (item) => {
    setSelectedListItem(item);
  };

  useEffect(() => {
    setRowData([]);
    if (campaginData && campaginData) {
      let finalColumn = campaginData.headerColumnNames;
      for (let i = 0; i < finalColumn.length; i++) {
        const mdata = finalColumn[i];
        if (mdata.field === "reminder") {
          mdata.headerAlign = "center";
          mdata.align = "center";
          mdata.renderCell = () => {
            return (
              <div>
                <button
                  className={`text-[white] w-[8rem] bg-[#FEBB12]  font-medium rounded-md text-sm px-5 py-2.5 text-center`}
                >
                  Send Reminder
                </button>
              </div>
            );
          };
        }
        if (mdata.field === "reset") {
          mdata.headerAlign = "center";
          mdata.align = "center";
          mdata.renderCell = () => {
            return (
              <div>
                <button
                  className={`text-[white] w-[8rem]  bg-[#FEBB12] font-medium rounded-md text-sm px-5 py-2.5 text-center`}
                >
                  Reset
                </button>
              </div>
            );
          };
        }
        if (mdata.field === "createdAt") {
          mdata.renderCell = (p) => {
            return (
              <p className="text-sm font-medium text-[#2f2e37] ">
                {moment(p.row.createdAt).format("YYYY-MM-DD hh:mm:ss")}
                {/* <p>{moment.defaultFormat(p.row.createdAt)}</p> */}
              </p>
            );
          };
        }
        if (mdata.field === "expired_at") {
          mdata.renderCell = (p) => {
            return (
              <p className="text-sm font-medium text-[#2f2e37] ">
                {p.row.expired_at !== null
                  ? moment(p.row.expired_at).format("YYYY-MM-DD hh:mm:ss")
                  : "No Expiry Date"}
                {/* <p>{moment.defaultFormat(p.row.createdAt)}</p> */}
              </p>
            );
          };
        }
      }
      setHeaders(finalColumn);
      setRowData(campaginData.listBoardData);
      setallUsers(campaginData.totalUsers);
      let savedData = LocalStorageService.getObject(`selectedArray`);
      setSelectedUsersIds(savedData[pageNumber]);
    }
  }, [campaginData, pageNumber, pageSize]);

  useEffect(() => {
    let { emailTemplate, emailSubject, campaignEmail } = campaign;
    setMessage(emailTemplate);
    setEditorState(emailTemplate);
    setEmailSubject(emailSubject);
    setCampaignEmail(campaignEmail);
  }, [campaign]);

  useEffect(() => {
    props.listGetAllTags(campaign);
  }, [campaign]);

  useEffect(() => {
    if (tagsList && tagsList.length > 0) {
      settagListItems(tagsList);
    }
  }, [tagsList]);

  return (
    <div>
      <div className="mx-auto 2xl:w-9/12 xl:w-9/12 lg:w-9/12 w-11/12 mt-2 border border-[#BBBBBB70] rounded-md">
        <div className="bg-white rounded-md shadow-lg  w-full">
          <CustomToolbar
            selectedRows={selectedRows}
            selectedUsersIds={selectedUsersIds}
            campaign={campaign}
            total={allUsers}
            overAllSelectedUsers={overAllSelectedUsers}
            allSelectedUsersIds={allSelectedUsersIds}
            handelSearchCandidate={handelSearchCandidate}
            defaultApiCall={defaultApiCall}
            customStep={customStep}
          />

          {currentStep === "InvitedUsers" ? (
            <>
              {campaginData && campaginData ? (
                <div>
                  <div style={{ height: 700, width: "100%" }}>
                    <DataGrid
                      onSelectionModelChange={handleSelectionChange}
                      loading={isLoading}
                      rowCount={allUsers}
                      checkboxSelection={true}
                      rows={rowData}
                      onCellClick={handelCellClick}
                      keepNonExistentRowsSelected
                      columns={[...headers]}
                      onPageChange={(page) => {
                        handelPage(page);
                      }}
                      // sortModel={sortingModal}
                      onSortModelChange={(newSortModel) => {
                        setSortModel(
                          newSortModel.length > 0
                            ? newSortModel
                            : [{ field: null, sort: null }]
                        );
                      }}
                      enableCellSelect={true}
                      disableSelectionOnClick={true}
                      paginationMode="server"
                      page={pageNumber}
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) => {
                        setDataLoading(!dataLoading);
                        setPageSize(newPageSize);
                      }}
                      disableColumnMenu={true}
                      sortable={true}
                      componentsProps={{
                        pagination: {
                          labelRowsPerPage: "Candidate Per Page",
                        },
                      }}

                      //   initialState={{
                      //     pinnedColumns: { left: [GRID_CHECKBOX_SELECTION_COL_DEF.field] },
                      // }}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex justify-center items-center">
                  <img
                    src={toAbsoluteUrl("/media/nrp/dashboard/logo.gif")}
                    alt="TTG LOGO"
                    style={{
                      width: "100px",
                      height: "90px",
                    }}
                  />
                </div>
              )}
            </>
          ) : currentStep === "SingleInvite" ? (
            <div>
              <div className="mt-10 px-20 pb-20 flex flex-row justify-between items-center">
                <div className="2xl:w-5/12 xl:w-5/12 lg:w-6/12 w-8/12">
                  <form onSubmit={formik.handleSubmit} noValidate>
                    <Input
                      {...formik.getFieldProps("email")}
                      label="Email"
                      placeholder="Write Your Email Here"
                      type="email"
                      name="email"
                      autoComplete="off"
                    />

                    {formik.touched.email && formik.errors.email && (
                      <div>
                        <span className="text-red-600 text-base font-semibold">
                          {formik.errors.email}
                        </span>
                      </div>
                    )}
                    <Button
                      customStyle="w-[15rem] mt-6 bg-[#FEBB12] hover:bg-[#FEBB12]"
                      name="Send Invite"
                      type="submit"
                    />
                  </form>
                </div>
                <div className=" 2xl:w-5/12 xl:w-5/12 lg:w-6/12 w-3/12">
                  <img
                    src={toAbsoluteUrl("/media/nrp/invite/singleInvite.png")}
                  />
                </div>
              </div>
            </div>
          ) : currentStep === "ReminderInvite" ? (
            <div>
              <div className="mt-10 px-20 pb-20">
                <div className="2xl:w-7/12 xl:w-7/12 lg:w-8/12 w-8/12">
                  <ReactQuill
                    name="emailTemplate"
                    value={message}
                    onChange={(state) => setMessage(state)}
                    defaultValue={message}
                    style={{ height: 190, marginBottom: 60 }}
                  />

                  <DateTimePicker
                    getData={(newDate) => {
                      setNewExpiry(newDate);
                    }}
                    user={reminderUser}
                  />
                  <div className="flex justify-end items-end">
                    <Button
                      onClick={() => sendReminderHandle()}
                      customStyle="w-[15rem] mt-6 bg-[#FEBB12] hover:bg-[#FEBB12]"
                      name="Send Reminder"
                      type="submit"
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : currentStep === "ResetInvite" ? (
            <div>
              <div className="mt-10 px-20 pb-20">
                <div className="2xl:w-5/12 xl:w-5/12 lg:w-6/12 w-8/12">
                  <DateTimePicker
                    getData={(newDate) => {
                      setNewExpiry(newDate);
                    }}
                    user={resetUser}
                  />
                </div>
                <div>
                  <Button
                    onClick={() => resetInviteHandle()}
                    customStyle="w-[15rem] mt-6 bg-[#FEBB12] hover:bg-[#FEBB12]"
                    name="Reset Invite"
                    type="submit"
                  />
                </div>
              </div>
            </div>
          ) : currentStep === "InviteTemplate" ? (
            <div>
              <div className="mt-10 px-20 pb-20">
                <div className="2xl:w-9/12 xl:w-9/12 lg:w-9/12 w-8/12">
                  <Input
                    label="Campaign Email Address"
                    placeholder="Write Your Email Here"
                    type="email"
                    name="email"
                    autoComplete="off"
                    value={campaignEmail}
                    onChange={(e) => setCampaignEmail(e.target.value)}
                  />

                  <Input
                    label="Email Subject"
                    placeholder="Write Your Email Here"
                    type="email"
                    name="email"
                    autoComplete="off"
                    value={emailSubject}
                    onChange={(e) => setEmailSubject(e.target.value)}
                  />

                  <p className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-6">
                    Email Template
                  </p>
                  <ReactQuill
                    name="emailTemplate"
                    value={editorState}
                    onChange={(state) => setEditorState(state)}
                    defaultValue={message}
                    style={{ height: 240, marginBottom: 60 }}
                  />

                  <div>
                    <p className="text-[#4B4141E5] font-medium text-sm">
                      You can include the following{" "}
                      <span className="text-[#007E8C]">#hashtags</span> tags in
                      your email template.
                    </p>

                    <button className="bg-[#007E8C33] px-10 py-3 mt-4 rounded-full">
                      <p>#CampaignName</p>
                    </button>
                  </div>
                </div>
                <div>
                  <Button
                    onClick={() => saveEmailTemplate()}
                    customStyle="w-[15rem] mt-6 bg-[#FEBB12] hover:bg-[#FEBB12]"
                    name="Save"
                    type="submit"
                  />
                </div>
              </div>
            </div>
          ) : currentStep === "BulkInvite" ? (
            <div>
              <div className="mt-10 px-20 pb-20 flex flex-row justify-between items-center">
                <div className="2xl:w-5/12 xl:w-5/12 lg:w-6/12 w-8/12">
                  <h5 className="text-[#333333]">Send Bulk Email Invites</h5>
                  <div className="mt-6">
                    <UploadFile
                      accept=".csv, text/csv"
                      value={bulkInviteFileName}
                      title="Please upload document containing your invites"
                      onChange={(event) => uploadBulkInvites(event)}
                    />
                    <CSVLink
                      data={dummyEmails}
                      className="text-[#007E8C] font-normal text-sm"
                    >
                      Download Sample File
                    </CSVLink>
                  </div>
                  <div>
                    <Button
                      onClick={() => bulkInvitesHandle()}
                      customStyle={`w-[15rem] mt-6   ${
                        bulkInviteEmails.length > 0
                          ? "bg-[#FEBB12]"
                          : "bg-gray-400  hover:bg-bg-gray-400"
                      }
                    
                    ${
                      bulkInviteEmails.length > 0
                        ? "hover:bg-[#FEBB12]"
                        : "hover:bg-gray-400"
                    }
                    `}
                      name="Send Invites"
                      type="submit"
                      disabled={bulkInviteEmails.length > 0 ? false : true}
                    />
                  </div>
                </div>

                <div className=" 2xl:w-5/12 xl:w-5/12 lg:w-6/12 w-3/12">
                  <img
                    src={toAbsoluteUrl("/media/nrp/invite/bulkInvite.png")}
                  />
                </div>
              </div>
            </div>
          ) : currentStep === "ListInvite" ? (
            <div className="mt-10 px-20 pb-20 flex flex-row justify-between items-center">
              <div className="2xl:w-5/12 xl:w-5/12 lg:w-6/12 w-8/12">
                <h5 className="text-[#333333]">Send Email Invites to Lists</h5>
                <div className="mt-6">
                  <div className="my-4">
                    <p className="text-lg my-3 font-medium text-[#333333]">
                      Please select the lists to send email invites
                    </p>
                    {taglistItems && taglistItems ? (
                      <Select
                        style={{ width: 300 }}
                        values={selectedListItem}
                        searchable={true}
                        options={taglistItems}
                        onChange={(values) => handleDropdown(values)}
                        placeholder={"Select List"}
                      />
                    ) : null}
                  </div>
                </div>
                <div>
                  <Button
                    onClick={() => listEmailInvitesHandle()}
                    customStyle={`w-[15rem] mt-6 ${"bg-[#FEBB12] hover:bg-[#FEBB12]"}  `}
                    name="Send Invites"
                    type="submit"
                  />
                </div>
              </div>
              <div className=" 2xl:w-5/12 xl:w-5/12 lg:w-6/12 w-3/12">
                <img src={toAbsoluteUrl("/media/nrp/invite/listInvite.png")} />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  getListsCampaignData,
  listGetAllTags,
  sendSingleInvite,
  resetInvite,
  sendReminder,
  saveTemplate,
  bulkInvites,
  getCustomListEmails,
})(Invite);
